import { ChainConfig } from "@silo/types";
import { satisfies } from "effect/Function";
import { TOKEN_ADDRESS } from "../token-address";

export const optimism = satisfies<ChainConfig>()({
  tokens: {
    [TOKEN_ADDRESS.optimism.ezETH]: {
      name: "Renzo",
    },
  },
} as const);
